import { Route } from "react-router-dom";
import AuthorizedRoute from "../../components/routing/authorized-route";
import { Roles } from "../../components/routing/utils";

import Sensors from "./page.highorder";

const ProtectedSensors = () => (
  <AuthorizedRoute
    requiredRoles={[Roles.ADMIN, Roles.NURSEADMIN]}
    component={Sensors}
  />
);

const sensorsRoute = (
  <Route path="/manage-sensors" element={<ProtectedSensors />} />
);

export default sensorsRoute;
